import { render, staticRenderFns } from "./MessageNavigation.vue?vue&type=template&id=e5b307f4&"
import script from "./MessageNavigation.vue?vue&type=script&lang=js&"
export * from "./MessageNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports